import { DocumentationValidation } from './DocumentationValidator'

export class DocumentationValidatorResolver {
  private _validators: DocumentationValidation[]

  constructor (validators: DocumentationValidation[]) {
    this._validators = validators
  }

  resolve (validatorType: string): DocumentationValidation {
    let foundValidator: DocumentationValidation | null = null
    for (const validator of this._validators) {
      if (validator.procedureType() === validatorType) {
        foundValidator = validator
      }
    }
    if (foundValidator === null) {
      throw new RangeError(`${validatorType} not found`)
    }
    return foundValidator
  }
}
